<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="areaId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('发货地id')}}<template slot="title">{{$t('发货地id')}}</template>
          </a-tooltip>
        </span>
        <a-tree-select v-model="form.areaId" style="width: 100%"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cityList" placeholder="请选择"
                       :replaceFields="{ children: 'children', title: 'areaName', key: 'areaId', value: 'areaId' }">
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item prop="destinationAreaId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('目的地id')}}<template slot="title">{{$t('目的地id')}}</template>
          </a-tooltip>
        </span>
        <a-tree-select v-model="form.destinationAreaId" style="width: 100%"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cityList" placeholder="请选择"
                       :replaceFields="{ children: 'children', title: 'areaName', key: 'areaId', value: 'areaId' }">
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item prop="distance" >
        <span slot="label" >
          <a-tooltip>
            {{$t('距离 km')}}<template slot="title">{{$t('距离 km')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.distance" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')"  :placeholder="$t('请输入')+$t('距离 km')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAreaDistance, addAreaDistance, updateAreaDistance } from '@/api/goods/areaDistance'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import {cityListTree} from "@/api/logistics";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      cityList: [],
      citySelected: [],
      // 表单参数
      form: {
        id: null,

        areaId: null,

        areaName: null,

        destinationAreaId: null,

        destinationAreaName: null,

        distance: null,

        status: 0,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        areaId: [
          { required: true, message: this.$t('发货地id')+this.$t('不能为空'), trigger: 'change' }
        ],
        destinationAreaId: [
          { required: true, message: this.$t('目的地id')+this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getCityTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        areaId: null,
        areaName: null,
        destinationAreaId: null,
        destinationAreaName: null,
        distance: null,
        status: 0,
        createTime: null,
      }

    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    onCityChange() {
      this.form.areaId = this.citySelected[0]
      this.form.areaName =this.citySelected[1]
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAreaDistance({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateAreaDistance(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addAreaDistance(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
